import { useTranslation } from 'react-i18next'

import { useDateLocale, useTimeZone } from '../../../../hooks'
import Text from '../../../Text'
import { useCalendarGridContext } from '../../CalendarGrid.hooks'
import { getCalendarGridPopoverSecondaryLabel } from '../../CalendarGrid.utils'
import { CalendarGridCard } from '../../CalendarGridCard'
import { CalendarGridItemStatus } from '../../CalendarGridItemStatus'
import { QA_NAME_CALENDAR_GRID_ITEM_CARD } from '../CalendarGridItemCard.constants'

import { getCalendarGridItemCardMeta } from './CalendarGridItemCardContent.utils'

function CalendarGridItemCardContent({ item, onClickItem, onClose }) {
  const { t } = useTranslation()

  const locale = useDateLocale()
  const timezone = useTimeZone()

  const { ItemCard } = useCalendarGridContext()

  const secondaryLabel = getCalendarGridPopoverSecondaryLabel(item)

  return ItemCard ? (
    <ItemCard item={item} onClickItem={onClickItem} onClose={onClose} />
  ) : (
    <CalendarGridCard
      meta={getCalendarGridItemCardMeta({ item, locale, t, timezone })}
      qaName={QA_NAME_CALENDAR_GRID_ITEM_CARD}
      title={item.title}
      titleUrl={item.url}
      onClose={onClose}
    >
      <CalendarGridItemStatus item={item} />
      {secondaryLabel ? <Text isSecondary>{secondaryLabel}</Text> : null}
    </CalendarGridCard>
  )
}

export default CalendarGridItemCardContent
